module.exports = __webpack_public_path__ + "static/media/gloria-lose.e73c433d.png";